export { VideoSlider } from './VideoSlider';
